var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4C6 1.791 7.791 0 10 0C12.209 0 14 1.791 14 4C14 6.209 12.209 8 10 8C7.791 8 6 6.209 6 4ZM7.5 64C9.433 64 11 62.433 11 60.5C11 58.567 9.433 57 7.5 57C5.567 57 4 58.567 4 60.5C4 62.433 5.567 64 7.5 64ZM57.5 25H47.5C45.567 25 44 26.567 44 28.5C44 30.433 45.567 32 47.5 32H49C51.209 32 53 33.791 53 36C53 38.209 51.209 40 49 40H48.5C47.119 40 46 41.119 46 42.5C46 43.881 47.119 45 48.5 45H54C56.209 45 58 46.791 58 49C58 51.209 56.209 53 54 53H46C44.895 53 44 53.895 44 55C44 56.105 44.895 57 46 57H46.5C48.433 57 50 58.567 50 60.5C50 62.433 48.433 64 46.5 64H17.5C15.567 64 14 62.433 14 60.5C14 58.567 15.567 57 17.5 57C18.881 57 20 55.881 20 54.5C20 53.119 18.881 52 17.5 52H9C6.791 52 5 50.209 5 48C5 45.791 6.791 44 9 44H13.5C15.433 44 17 42.433 17 40.5C17 38.567 15.433 37 13.5 37H5C2.239 37 0 34.761 0 32C0 29.239 2.239 27 5 27H8C9.657 27 11 25.657 11 24C11 22.343 9.657 21 8 21H5.5C3.567 21 2 19.433 2 17.5C2 15.567 3.567 14 5.5 14H24C25.657 14 27 12.657 27 11C27 9.343 25.657 8 24 8H22C19.791 8 18 6.209 18 4C18 1.791 19.791 0 22 0H46C48.209 0 50 1.791 50 4C50 6.209 48.209 8 46 8H44C41.791 8 40 9.791 40 12C40 14.209 41.791 16 44 16H57.5C59.985 16 62 18.015 62 20.5C62 22.985 59.985 25 57.5 25ZM63 36C63 33.791 61.209 32 59 32C56.791 32 55 33.791 55 36C55 38.209 56.791 40 59 40C61.209 40 63 38.209 63 36Z",
    fill: "#BEBEBE",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.846 49.998L55.852 49.992L43.621 37.761C45.752 34.528 47 30.662 47 26.5C47 15.178 37.822 6 26.5 6C15.178 6 6 15.178 6 26.5C6 37.822 15.178 47 26.5 47C30.663 47 34.531 45.751 37.765 43.619L49.997 55.848C51.539 57.39 54.037 57.39 55.578 55.848L55.846 55.58C57.385 54.038 57.385 51.54 55.846 49.998Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12C22.6544 12 18.9662 13.5277 16.247 16.247C13.5277 18.9662 12 22.6544 12 26.5C12 30.3456 13.5277 34.0338 16.247 36.753C18.9662 39.4723 22.6544 41 26.5 41C30.3456 41 34.0338 39.4723 36.753 36.753C39.4723 34.0338 41 30.3456 41 26.5C41 22.6544 39.4723 18.9662 36.753 16.247C34.0338 13.5277 30.3456 12 26.5 12Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12C27.881 12 29 13.119 29 14.5C29 15.881 27.881 17 26.5 17H23C21.895 17 21 17.895 21 19C21 20.105 21.895 21 23 21H23.5C24.881 21 26 22.119 26 23.5C26 24.881 24.881 26 23.5 26H19C17.895 26 17 26.895 17 28C17 29.105 17.895 30 19 30H19.5C20.881 30 22 31.119 22 32.5C22 33.881 20.881 35 19.5 35H14.77C13.035 32.61 12 29.679 12 26.5C12 18.492 18.492 12 26.5 12ZM30.5 21C29.119 21 28 22.119 28 23.5C28 24.881 29.119 26 30.5 26C31.881 26 33 24.881 33 23.5C33 22.119 31.881 21 30.5 21Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23H24.5C24.1022 23 23.7206 23.1639 23.4393 23.4556C23.158 23.7473 23 24.143 23 24.5556C23 24.9681 23.158 25.3638 23.4393 25.6555C23.7206 25.9472 24.1022 26.1111 24.5 26.1111H26V35.4444C26 35.857 26.158 36.2527 26.4393 36.5444C26.7206 36.8361 27.1022 37 27.5 37C27.8978 37 28.2794 36.8361 28.5607 36.5444C28.842 36.2527 29 35.857 29 35.4444V26.1111C29 25.286 28.6839 24.4947 28.1213 23.9112C27.5587 23.3278 26.7956 23 26 23Z",
    fill: "#DB095B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20C27.1046 20 28 19.1046 28 18C28 16.8954 27.1046 16 26 16C24.8954 16 24 16.8954 24 18C24 19.1046 24.8954 20 26 20Z",
    fill: "#DB095B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31.5,
    y1: 6,
    x2: 31.5,
    y2: 57.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 26.5,
    y1: 12,
    x2: 26.5,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#CFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#A7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 22.5,
    y1: 35,
    x2: 22.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#EAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.701482d46efc58b55ce8e92ea87f67d1.svg";
export { ForwardRef as ReactComponent };